import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ButtonSize,
  ButtonVariant,
} from '@app/modules/editor/shared/as-components/button/button.component';

export interface BackgroundColorData {
  color: string;
}

@Component({
  selector: 'inline-ediot-slider-select-color',
  standalone: false,
  templateUrl: './inline-ediot-slider-select-color.component.html',
  styleUrls: ['./inline-ediot-slider-select-color.component.scss'],
})
export class InlineEdiotSliderSelectColorComponent {
  color: string;

  btnSize = ButtonSize;
  btnVariant = ButtonVariant;

  constructor(
    private dialogRef: MatDialogRef<InlineEdiotSliderSelectColorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BackgroundColorData
  ) {
    this.color = this.rgbaToHex(data.color || '#ffffff');
  }

  save() {
    this.dialogRef.close({
      action: 'save',
      color: this.normalizeToRgba(this.color),
    });
  }

  cancel() {
    this.dialogRef.close({ action: 'cancel' });
  }

  normalizeToRgba(colorStr) {
    const ctx = document.createElement('canvas').getContext('2d')!;
    ctx.fillStyle = colorStr;
    // tu mówimy TS “zaufaj mi, to na pewno string”
    const normalized = ctx.fillStyle as string;

    if (normalized.startsWith('#')) {
      const hex = normalized.slice(1);
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, 1)`;
    }

    return normalized;
  }

  rgbaToHex(rgba: string): string {
    const m = rgba.match(/rgba?\(\s*(\d+),\s*(\d+),\s*(\d+)/i);
    if (!m) {
      return rgba;
    }
    const r = parseInt(m[1], 10);
    const g = parseInt(m[2], 10);
    const b = parseInt(m[3], 10);
    const hr = r.toString(16).padStart(2, '0');
    const hg = g.toString(16).padStart(2, '0');
    const hb = b.toString(16).padStart(2, '0');

    return `#${hr}${hg}${hb}`;
  }
}
